import { Avatar } from '@mui/material';

export default function UserAvatar({ avatar, sx, onClick }) {
  const avatarStyles = {
    cursor: 'pointer',
    ...sx,
  };

  return <Avatar src={avatar} sx={avatarStyles} onClick={onClick} />;
}
